export const getToken = () => localStorage.getItem('jwtToken');

export const setToken = (token) => {
    localStorage.setItem('jwtToken', token);
};

const removeToken = () => localStorage.removeItem('jwtToken');

export const setCurrentBranchUuId = (branchId) => {
    localStorage.setItem('currentBranchUuId', branchId);
    localStorage.setItem('defaultBranchUuId', branchId);
};

export const getCurrentBranchUuId = () => localStorage.getItem('currentBranchUuId');

export const getDefaultBranchUuId = () => localStorage.getItem('defaultBranchUuId');

export const removeCurrentBranchUuId = () => localStorage.removeItem('currentBranchUuId');

export const clearStorage = () => {
    removeToken();
    removeCurrentBranchUuId();
};

export const logout = () => {
    clearStorage();
    window.location.reload()
};
